(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-order-home/assets/javascript/components/scroll-to-top.js') >= 0) return;  svs.modules.push('/modules/tickets-order-home/assets/javascript/components/scroll-to-top.js');
"use strict";


const {
  useEffect
} = React;
const {
  useLocation
} = ReactRouterDOM;
setGlobal('svs.ticketsOrderHome.components.ScrollToTop', () => {
  const {
    pathname
  } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 1);
  }, [pathname]);
  return null;
});

 })(window);